export const COOKIE_DISCLAIMER_TOKEN = 'cc';
export const APARTMENT_STAGED_FOR_APPLICATION_TOKEN = 'apartmentStagedForApplication';
